import { useState } from 'react';

/**
 * The current page of a filtered list, back to the first page whenever the
 * filters change.
 *
 * The list pages reset the page in an effect after a filter changed. By then
 * the fetch effect had already run with the new filter and the old page, so
 * every filter change made from a later page sent two requests, the first for
 * a page that was usually wrong. If that one answered last, its rows replaced
 * the right ones. Resetting during render, which React re-runs before any
 * effect, means the fetch only ever sees the new filter with page 1.
 *
 * `filterKey` is anything that changes when the filters do, e.g. the filter
 * values joined into one string.
 */
export const useListPage = (filterKey) => {
  const [page, setPage] = useState(1);
  const [pagedKey, setPagedKey] = useState(filterKey);

  if (filterKey !== pagedKey) {
    setPagedKey(filterKey);
    setPage(1);
  }

  return [page, setPage];
};

export default useListPage;
